import * as Yup from "yup";

export class EstadoSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um maior que zero");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      nome,
      uf,
      pais,
    } = recordShape;

    const createFormShape = {
      nome,
      uf,
      pais,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      nome,
      uf,
      pais,
    } = recordShape;

    const updateFormShape = {
      nome,
      uf,
      pais,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  nome: Yup.string(),
  uf: Yup.string(),
  pais: Yup.number(),
};
